export interface RedirectTarget {
	name: string;
	url: string;
	en: string;
	de: string;
}

export const REDIRECT_TARGETS: RedirectTarget[] = [
	{ name: 'WEDIREKT', url: 'wedirekt.com', en: 'WE Direkt', de: 'WE Direkt' },
	{
		name: 'MYWE-dev',
		url: 'monorepo-service-we-cep.apps.ocp-dev01.wgn.wuerth.com',
		en: 'MyWE',
		de: 'MyWE',
	},
	{
		name: 'MYWE-prod',
		url: 'mywe.we-online.com',
		en: 'MyWE',
		de: 'MyWE',
	},
	{
		name: 'REDEXPERT',
		url: 'localhost:4200',
		en: 'Red Expert',
		de: 'Red Expert',
	},
	{
		name: 'REDEXPERT',
		url: 'redexpert.we-online.com',
		en: 'REDEXPERT',
		de: 'REDEXPERT',
	},
	{
		name: 'REDEXPERT',
		url: 'redexpert-dev.we-online.com',
		en: 'Red Expert',
		de: 'Red Expert',
	},
	{
		name: 'REDEXPERT',
		url: 'redexpert-test.we-online.com',
		en: 'REDEXPERT',
		de: 'REDEXPERT',
	},
	{
		name: 'POWERELEMENT',
		url: 'powerelement.we-online.de',
		en: 'Power Element',
		de: 'Power Element',
	},
	{
		name: 'USERPROFILE-dev',
		url: 'we-userprofile.apps.ocp-dev01.wgn.wuerth.com',
		en: 'WE User Profile',
		de: 'WE User Profile',
	},
	{
		name: 'USERPROFILE-prod',
		url: 'profile.we-online.com',
		en: 'WE User Profile',
		de: 'WE User Profile',
	},
	{ name: 'WEBSITE', url: 'we-online.com', en: 'Website', de: 'Webseite' },
];
